import {Box, SxProps, Typography, Theme} from '@mui/material';
import {DefaultTFuncReturn} from 'i18next';
import React from 'react';

interface Props {
  label?: string | DefaultTFuncReturn;
  borderColor?: string;
  backgroundColor?: string;
  sx?: SxProps<Theme>;
}

const GraphLegendItem: React.FC<Props> = ({
  label,
  borderColor,
  backgroundColor,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 25,
        mb: 1,
        ...sx,
      }}>
      {(borderColor || backgroundColor) && (
        <Box
          sx={{
            height: 25,
            width: 25,
            border: borderColor ? `2px solid ${borderColor}` : undefined,
            backgroundColor,
            mr: 1,
          }}
        />
      )}
      <Typography variant="h4">{label}</Typography>
    </Box>
  );
};

export default GraphLegendItem;
